import { css } from 'styled-system/css';
import { ROWS, WIDE_HEAD } from '../featureMockups/sheetData';
import { IsoFace } from './IsoFace';
import {
  CELL_HEIGHT,
  CELL_WIDTH,
  COLUMN_COUNT,
  GRID_DEPTH,
  GRID_WIDTH,
  ROW_COUNT,
  SHEET_RADIUS,
} from './isometric';

export function SheetLayer() {
  return (
    <IsoFace x={0} y={0} z={0}>
      <defs>
        <linearGradient
          id="iso-prism"
          gradientUnits="userSpaceOnUse"
          x1={0}
          y1={0}
          x2={GRID_WIDTH}
          y2={GRID_DEPTH}
        >
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="50%" stopColor="#46aebf" />
          <stop offset="100%" stopColor="#00ff88" />
        </linearGradient>
      </defs>
      <rect
        width={GRID_WIDTH}
        height={GRID_DEPTH}
        rx={SHEET_RADIUS}
        ry={SHEET_RADIUS}
        className={css({ fill: 'bg.page' })}
        style={{ stroke: 'url(#iso-prism)' }}
      />
      <g clipPath="url(#iso-sheet)" style={{ stroke: 'url(#iso-prism)' }}>
        {Array.from({ length: COLUMN_COUNT + 1 }, (_, i) => (
          <line
            key={`c${i}`}
            x1={i * CELL_WIDTH}
            y1={0}
            x2={i * CELL_WIDTH}
            y2={GRID_DEPTH}
            className={css({ strokeWidth: '0.6', opacity: 0.55 })}
          />
        ))}
        {Array.from({ length: ROW_COUNT + 1 }, (_, i) => (
          <line
            key={`r${i}`}
            x1={0}
            y1={i * CELL_HEIGHT}
            x2={GRID_WIDTH}
            y2={i * CELL_HEIGHT}
            className={css({
              strokeWidth: i === 1 ? '1.1' : '0.6',
              opacity: i === 1 ? 0.85 : 0.55,
            })}
          />
        ))}
        {WIDE_HEAD.map((label, i) => (
          <text
            key={label}
            x={i * CELL_WIDTH + 4}
            y={12}
            className={css({
              fill: 'text.faint',
              stroke: 'none',
              fontSize: '8px',
            })}
          >
            {label}
          </text>
        ))}
        {ROWS.slice(0, ROW_COUNT - 1).map((row, i) => (
          <g key={row.ticker}>
            {[row.ticker, ...row.nums].map((value, c) => (
              <text
                key={c}
                x={c * CELL_WIDTH + 4}
                y={(i + 1) * CELL_HEIGHT + 12}
                className={css({
                  fill: 'text.muted',
                  stroke: 'none',
                  fontSize: '7.5px',
                })}
              >
                {value}
              </text>
            ))}
          </g>
        ))}
      </g>
    </IsoFace>
  );
}
